module.exports = __webpack_public_path__ + "media/assets/article-icon-0-7f3fbc49ed17714c670591aee09513f1b141c5eb2d93176516ca392f512f8094.png";